// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__f8b3Y","spin":"Loader_spin__feCPR","inside":"Loader_inside__+Ai4d"};